var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlackCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_236",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161435",
    "data-name": "Group 161435",
    transform: "translate(-384 -260)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 384, 260)",
    filter: "url(#Ellipse_236)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236-2",
    "data-name": "Ellipse 236",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(6 4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Slack_logo",
    transform: "translate(-266 -262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Slack_logo-2",
    "data-name": "Slack_logo",
    transform: "translate(5.074 5.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161433",
    "data-name": "Group 161433",
    transform: "translate(666.913 536.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83274",
    "data-name": "Path 83274",
    d: "M7.526,70.163A3.363,3.363,0,1,1,4.163,66.8H7.526Zm1.682,0a3.363,3.363,0,0,1,6.726,0v8.408a3.363,3.363,0,0,1-6.726,0Z",
    transform: "translate(-0.775 -49.934)",
    fill: "#e01e5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83275",
    "data-name": "Path 83275",
    d: "M12.5,7.326a3.363,3.363,0,1,1,3.363-3.363V7.326Zm0,1.707a3.363,3.363,0,1,1,0,6.726H4.063a3.363,3.363,0,1,1,0-6.726Z",
    transform: "translate(-0.7 -0.6)",
    fill: "#36c5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83276",
    "data-name": "Path 83276",
    d: "M75.308,12.4a3.363,3.363,0,1,1,3.363,3.363H75.308Zm-1.682,0a3.363,3.363,0,1,1-6.726,0V3.963a3.363,3.363,0,1,1,6.726,0Z",
    transform: "translate(-50.034 -0.6)",
    fill: "#2eb67d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83277",
    "data-name": "Path 83277",
    d: "M70.263,75.208A3.363,3.363,0,1,1,66.9,78.571V75.208Zm0-1.682a3.363,3.363,0,1,1,0-6.726H78.7a3.363,3.363,0,0,1,0,6.726Z",
    transform: "translate(-50.034 -49.934)",
    fill: "#ecb22e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackCircleIcon);
export default __webpack_public_path__ + "static/media/slack-circle-icon.ae1c21c78110a82c1b3fdcd968268a49.svg";
export { ForwardRef as ReactComponent };